import { render } from "./DataSourceType.vue?vue&type=template&id=622c3f96&ts=true"
import script from "./DataSourceType.vue?vue&type=script&lang=ts"
export * from "./DataSourceType.vue?vue&type=script&lang=ts"

import "./DataSourceType.vue?vue&type=style&index=0&id=622c3f96&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__